// components/VerticalMarquee.jsx
import React from "react";

const VerticalMarquee = ({
  direction = "up",
  speed = 15,
  height = "h-64",
  children,
}) => {
  const animationClass =
    direction === "down" ? "animate-marquee-down" : "animate-marquee-up";

  return (
    <div className={`${height} relative`}>
      <div
        className={`${animationClass} flex flex-col items-center gap-4`}
        style={{ animationDuration: `${speed}s` }}
      >
        {/* 🔁 Duplicate content for seamless loop */}
        <div className="flex flex-col items-center gap-4">
          {children}
        </div>
        <div className="flex flex-col items-center gap-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default VerticalMarquee;
